import { IAnyResult, RestClient } from 'slipstream-components';

const restClient = new RestClient();
const sseAPI = {
  async getSseToken(): Promise<IAnyResult> {
    return restClient.get('/csp-sse:get-random-string');
  },
};

export default sseAPI;
